module.exports = __webpack_public_path__ + "static/media/spike.da0d408c.png";